export const getMediaTypeFromUrl = (url: string) => {
  const cleanUrl = url.split("?")[0].toLowerCase();

  const audioExtensions = ["mp3", "wav", "aac", "ogg", "m4a", "flac"];
  const videoExtensions = [
    "mp4",
    "webm",
    "mov",
    "avi",
    "wmv",
    "flv",
    "mkv",
    "3gp",
    "ogv",
    "m3u8",
    "mpd",
  ];

  const ext = cleanUrl.split(".").pop();

  if (ext && audioExtensions.includes(ext)) return "audio";
  if (ext && videoExtensions.includes(ext)) return "video";

  return "unknown";
};
